// extracted by mini-css-extract-plugin
export default {"modal":"wJ7ne0","non-wave":"weSLiE","nonWave":"weSLiE","wave-section":"nOGnz2","waveSection":"nOGnz2","below-wave-section":"Gmrww8","belowWaveSection":"Gmrww8"};